// extracted by mini-css-extract-plugin
module.exports = {"root":"property-card_root__1Azaj","img":"property-card_img__3FIpf"};